// @flow

import './index.scss';
import * as React from 'react';
import { useTranslate } from '@insolus/react-i18n';
import Tag from '../Tag';
import Price from '../Price';
import __p from 'utils/__p';

import type { Ad } from 'stores/api/ads';

type Props = {|
    ad: Ad
|};

const AdCard = ({ ad }: Props): React.Node => {
    const { __ } = useTranslate();

    return (
        <a className="MachineCard" href={__p(`/ads/${ad.id}`)}>
            <figure className="MachineCard__picture">
                {ad.media && (
                    <img
                        className="MachineCard__image"
                        src={ad.media[0].paths.medium}
                        alt={`${ad.manufacturer.name} ${ad.modelName}`}
                    />
                )}
            </figure>
            <div className="MachineCard__details">
                {ad.priority && (
                    <span className="MachineCard__priority">{__('ad-priority')}</span>
                )}
                <div>
                    <div className="MachineCard__category">
                        {ad.category.name}
                    </div>
                    <div className="MachineCard__title">
                        {ad.manufacturer.name} {ad.modelName}
                    </div>
                    <div className="MachineCard__ad-condition">
                        {ad.adCondition.name}
                    </div>
                    <div className="MachineCard__price">
                        {ad.price
                            ? <Price value={ad.price} currency={ad.currency} />
                            : __('price-on-demand')}
                    </div>
                </div>
                <Tag value={ad.constructionYear} />
                {ad.operationHour && (
                    <Tag value={__('operation-hours-count', { count: ad.operationHour })} />
                )}
                {ad.weight && (
                    <Tag value={__('tons-count', { count: ad.weight })} />
                )}
                <address className="MachineCard__locality">
                    {ad.locality.fullName}
                </address>
            </div>
        </a>
    );
};

export default AdCard;
